import { t, type Locale } from '@budgeting101/i18n';
import { ResponsiveChoice } from '@budgeting101/ui-web';
import { useLanguageStore } from '../store/languageStore.js';

export function LanguageSelect({ compact = false }: { compact?: boolean }) {
  const locale = useLanguageStore((state) => state.locale);
  const setLocale = useLanguageStore((state) => state.setLocale);

  return (
    <div className={`language-select${compact ? ' language-select--compact' : ''}`}>
      <span className={compact ? 'sr-only' : undefined}>{t('language.label')}</span>
      <span className="material-symbols-outlined" aria-hidden="true">language</span>
      <ResponsiveChoice
        aria-label={t('language.label')}
        value={locale}
        onValueChange={(value) => setLocale(value as Locale)}
        mobileLabel={t('language.label')}
        options={[
          { value: 'en', label: compact ? 'EN' : t('language.english') },
          { value: 'ar', label: compact ? 'ع' : t('language.arabic') },
        ]}
      />
    </div>
  );
}
